import { render, staticRenderFns } from "./StateReportProblem.vue?vue&type=template&id=3345bcb1&scoped=true&"
import script from "./StateReportProblem.vue?vue&type=script&lang=js&"
export * from "./StateReportProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345bcb1",
  null
  
)

export default component.exports